<mat-form-field appearance="outline" *ngIf="inputFormControl">
    <mat-label>Tipo de Viaje</mat-label>
    <mat-select [formControl]="inputFormControl" (selectionChange)="onSelect($event)">
        <mat-option *ngFor="let typeTrip of typeTrips" [value]="typeTrip.type">
            {{typeTrip.label}}
        </mat-option>
    </mat-select>
</mat-form-field>